/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Inherited_Link_TenantInputs */

const en_settings_inherited_link_tenant = /** @type {(inputs: Settings_Inherited_Link_TenantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tenant`)
};

const de_settings_inherited_link_tenant = /** @type {(inputs: Settings_Inherited_Link_TenantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mandanten`)
};

/**
* | output |
* | --- |
* | "tenant" |
*
* @param {Settings_Inherited_Link_TenantInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const settings_inherited_link_tenant = /** @type {((inputs?: Settings_Inherited_Link_TenantInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Inherited_Link_TenantInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_inherited_link_tenant(inputs)
	return de_settings_inherited_link_tenant(inputs)
});